export interface DetectBrowserInfo {
	android?: {
		osVersion: string
		browserVersion: string
	},
	iOS?: boolean,
	webkit?: boolean,
	iOSSafari?: boolean,
}

/**
 * Minimal browser detection and addition of data-* attributes to a given
 * element based on detection.
 */
class DetectBrowser {
	private static info?: DetectBrowserInfo;

	public static getInfo(): DetectBrowserInfo {
		if (DetectBrowser.info === undefined) {
			const ua = navigator.userAgent.toLowerCase();
			const info: DetectBrowserInfo = {
				iOS: ua.includes("ipad") || ua.includes("iphone"),
				webkit: ua.includes("webkit")
			};
			info.iOSSafari = info.iOS !== undefined && info.webkit !== undefined && !ua.includes("crios");

			if (!/chrome|iemobile/g.test(ua)) {
				const androidMatch = /android\s([\d.]*).+version\/\s*([\d.]*)/g.exec(ua);
				if (androidMatch) {
					info.android = {
						osVersion: androidMatch[1] || "0",
						browserVersion: androidMatch[2] || "0"
					};
				}
			}

			DetectBrowser.info = info;
		}
		return DetectBrowser.info;
	}
	
	public static applyAttributes(element: HTMLElement): void {
		const info = DetectBrowser.getInfo();
		
		if (info.android) {
			element.setAttribute('data-browser', 'android');
			element.setAttribute('data-osversion', info.android.osVersion);
			element.setAttribute('data-browserversion', info.android.browserVersion);
		}
		if (info.iOSSafari) {
			element.setAttribute('data-os', 'iOS');
			element.setAttribute('data-browser', 'Safari');
		}
	}
}

export default DetectBrowser;
